"use client";

import Image from "next/image";
import ResourcePopup from "../ResourcePopup/ResourcePopup";
import { useEffect, useState } from "react";
import useAnimatedXP from "@/hooks/useAnimatedXP";
import { useLocale, useTranslations } from "next-intl";

export default function Fragments({
    session,
    showTipsOnTop,
    withoutPopup = false,
    compact = false,
    hoverRounded = "rounded-xl",
}) {
    const locale = useLocale();
    const t = useTranslations("layout");

    const [openFragmentsInfos, setOpenFragmentsInfos] = useState(false);

    const [fragments, setFragments] = useState(0);

    const dynamicFragments = useAnimatedXP(fragments);

    useEffect(() => {
        if (session && session.user) {
            setFragments(session.user.fragments);
        }
    }, [session]);

    const displayValue =
        compact && dynamicFragments >= 1000
            ? new Intl.NumberFormat(locale, {
                  notation: "compact",
                  maximumFractionDigits: 1,
              }).format(dynamicFragments)
            : dynamicFragments.toLocaleString(locale);

    return (
        <div
            className={`flex items-center gap-1.5 hover:background-blur dark:hover:bg-white/10 duration-100 cursor-pointer p-2 ${hoverRounded} relative`}
            onMouseOver={() => setOpenFragmentsInfos(true)}
            onMouseOut={() => setOpenFragmentsInfos(false)}
            title={compact ? fragments.toLocaleString(locale) : undefined}
        >
            <Image
                src="/static/icons/fragment.svg"
                width={15}
                height={18}
                alt=""
            />
            <div className="text-sm text-gray-800/70 dark:text-lightBlue font-bold font-geistMono tabular-nums">
                {displayValue}
            </div>

            <ResourcePopup
                open={openFragmentsInfos && !withoutPopup}
                showTipsOnTop={showTipsOnTop}
                icon={
                    <Image
                        src="/static/icons/fragment.svg"
                        width={18}
                        height={22}
                        alt=""
                    />
                }
                title={t("Fragments_title")}
                cta={{
                    href: "/fragments",
                    label: t("Fragments_showMyFragments"),
                    variant: "default",
                }}
            >
                <div className="text-[#06050F]/60 dark:text-lightBlue font-geistSans text-sm mt-1">
                    {t("Fragments_description")}
                </div>
            </ResourcePopup>
        </div>
    );
}
